// @ts-nocheck
import _ from "lodash";
import { Organization, User } from "../../redux/reducers/types";
import { EmailState, Action, ActionList } from "../../types";
import {
  genderOptions,
  pronounsOptions,
  ethnicityOptions,
} from "../Constants/DropdownOptions";

import _clone from "lodash/clone";
import _escapeRegExp from "lodash/escapeRegExp";
import _uniqBy from "lodash/uniqBy";

export const removeDuplicates = (array: Array<EmailState>) => {
  const uniqueObjects = {};
  const resultArray: Array<EmailState> = [];

  array.forEach((obj) => {
    // Use the 'text' property as the key to check for uniqueness
    const email = obj.email;
    if (!uniqueObjects[email]) {
      // If the text is not found in the uniqueObjects, add it to the object and resultArray
      uniqueObjects[email] = true;
      resultArray.push(obj);
    }
  });

  return resultArray;
};

export const removeKeysFromEmails = (emails: Array<EmailState>) =>
  emails.map(({ email, id }) => ({ email, id }));

/** Country options for location (US first for backward compatibility, then A–Z). */
export const COUNTRY_OPTIONS = [
  { label: "United States", value: "United States" },
  { label: "Afghanistan", value: "Afghanistan" },
  { label: "Albania", value: "Albania" },
  { label: "Algeria", value: "Algeria" },
  { label: "Argentina", value: "Argentina" },
  { label: "Australia", value: "Australia" },
  { label: "Austria", value: "Austria" },
  { label: "Bangladesh", value: "Bangladesh" },
  { label: "Belgium", value: "Belgium" },
  { label: "Brazil", value: "Brazil" },
  { label: "Canada", value: "Canada" },
  { label: "Chile", value: "Chile" },
  { label: "China", value: "China" },
  { label: "Colombia", value: "Colombia" },
  { label: "Costa Rica", value: "Costa Rica" },
  { label: "Egypt", value: "Egypt" },
  { label: "Ethiopia", value: "Ethiopia" },
  { label: "France", value: "France" },
  { label: "Germany", value: "Germany" },
  { label: "Ghana", value: "Ghana" },
  { label: "India", value: "India" },
  { label: "Indonesia", value: "Indonesia" },
  { label: "Ireland", value: "Ireland" },
  { label: "Israel", value: "Israel" },
  { label: "Italy", value: "Italy" },
  { label: "Jamaica", value: "Jamaica" },
  { label: "Japan", value: "Japan" },
  { label: "Kenya", value: "Kenya" },
  { label: "Mexico", value: "Mexico" },
  { label: "Netherlands", value: "Netherlands" },
  { label: "Nigeria", value: "Nigeria" },
  { label: "Pakistan", value: "Pakistan" },
  { label: "Philippines", value: "Philippines" },
  { label: "Poland", value: "Poland" },
  { label: "Portugal", value: "Portugal" },
  { label: "South Africa", value: "South Africa" },
  { label: "South Korea", value: "South Korea" },
  { label: "Spain", value: "Spain" },
  { label: "United Kingdom", value: "United Kingdom" },
  { label: "Vietnam", value: "Vietnam" },
  { label: "Zimbabwe", value: "Zimbabwe" },
];

/** States/regions per country (for dropdown when not US). Only countries with data get state/city dropdowns; others stay manual input. */
export const COUNTRY_STATES: Record<string, string[]> = {
  Pakistan: [
    "Punjab",
    "Sindh",
    "Khyber Pakhtunkhwa",
    "Balochistan",
    "Gilgit-Baltistan",
    "Islamabad",
    "Azad Jammu and Kashmir",
  ],
  India: [
    "Andhra Pradesh",
    "Bihar",
    "Delhi",
    "Gujarat",
    "Karnataka",
    "Maharashtra",
    "Punjab",
    "Rajasthan",
    "Tamil Nadu",
    "Uttar Pradesh",
    "West Bengal",
  ],
  "United Kingdom": ["England", "Scotland", "Wales", "Northern Ireland"],
  Canada: [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Nova Scotia",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
  ],
  Australia: [
    "New South Wales",
    "Victoria",
    "Queensland",
    "Western Australia",
    "South Australia",
    "Tasmania",
    "Northern Territory",
    "Australian Capital Territory",
  ],
};

/** Cities by country and state (for dropdown when not US). */
export const COUNTRY_CITIES_BY_STATE: Record<string, Record<string, string[]>> = {
  Pakistan: {
    Punjab: ["Lahore", "Faisalabad", "Rawalpindi", "Multan", "Gujranwala", "Sialkot", "Sargodha", "Bahawalpur", "Sheikhupura", "Jhang", "Kasur", "Sahiwal", "Okara", "Mianwali", "Pakpattan", "Attock", "Hafizabad", "Gujrat", "Narowal", "Lodhran"],
    Sindh: ["Karachi", "Hyderabad", "Sukkur", "Larkana", "Nawabshah", "Mirpur Khas", "Jacobabad", "Shikarpur", "Khairpur", "Dadu", "Thatta", "Badin", "Sanghar", "Umerkot"],
    "Khyber Pakhtunkhwa": ["Peshawar", "Abbottabad", "Mardan", "Mingora", "Kohat", "Bannu", "Swabi", "Dera Ismail Khan", "Charsadda", "Nowshera", "Mansehra", "Haripur", "Chitral"],
    Balochistan: ["Quetta", "Gwadar", "Turbat", "Khuzdar", "Chaman", "Sibi", "Loralai", "Zhob", "Dera Bugti", "Mastung"],
    "Gilgit-Baltistan": ["Gilgit", "Skardu", "Hunza", "Chilas", "Astore", "Ghizer", "Ghanche", "Diamer"],
    Islamabad: ["Islamabad"],
    "Azad Jammu and Kashmir": ["Muzaffarabad", "Mirpur", "Rawalakot", "Kotli", "Bagh", "Bhimber", "Neelum", "Hattian", "Haveli", "Sudhnoti"],
  },
  India: {
    "Andhra Pradesh": ["Hyderabad", "Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool", "Rajahmundry", "Tirupati", "Kakinada", "Kadapa"],
    Bihar: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Darbhanga", "Purnia", "Arrah", "Begusarai", "Katihar", "Munger"],
    Delhi: ["New Delhi", "North Delhi", "South Delhi", "East Delhi", "West Delhi", "Central Delhi"],
    Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Junagadh", "Gandhinagar", "Anand", "Nadiad"],
    Karnataka: ["Bangalore", "Mysore", "Hubli", "Mangalore", "Belgaum", "Gulbarga", "Davanagere", "Bellary", "Bidar", "Shimoga"],
    Maharashtra: ["Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Aurangabad", "Solapur", "Kolhapur", "Amravati", "Navi Mumbai"],
    Punjab: ["Chandigarh", "Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", "Mohali", "Pathankot", "Hoshiarpur", "Moga"],
    Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Bikaner", "Ajmer", "Bhilwara", "Alwar", "Bharatpur", "Sikar"],
    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", "Tirunelveli", "Tiruppur", "Erode", "Vellore", "Thoothukudi"],
    "Uttar Pradesh": ["Lucknow", "Kanpur", "Ghaziabad", "Agra", "Varanasi", "Meerut", "Allahabad", "Bareilly", "Aligarh", "Moradabad"],
    "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri", "Bardhaman", "Malda", "Baharampur", "Habra", "Kharagpur"],
  },
  "United Kingdom": {
    England: ["London", "Birmingham", "Manchester", "Leeds", "Liverpool", "Sheffield", "Bristol", "Newcastle", "Nottingham", "Southampton", "Brighton", "Leicester", "Portsmouth", "Reading", "Plymouth"],
    Scotland: ["Edinburgh", "Glasgow", "Aberdeen", "Dundee", "Inverness", "Stirling", "Perth", "Paisley", "East Kilbride", "Livingston"],
    Wales: ["Cardiff", "Swansea", "Newport", "Wrexham", "Barry", "Neath", "Port Talbot", "Bridgend", "Caerphilly", "Llanelli"],
    "Northern Ireland": ["Belfast", "Derry", "Lisburn", "Newry", "Bangor", "Craigavon", "Castlereagh", "Ballymena", "Newtownabbey", "Newtownards"],
  },
  Canada: {
    Alberta: ["Calgary", "Edmonton", "Red Deer", "Lethbridge", "St. Albert", "Medicine Hat", "Grande Prairie", "Airdrie", "Spruce Grove", "Fort Saskatchewan"],
    "British Columbia": ["Vancouver", "Victoria", "Surrey", "Burnaby", "Richmond", "Abbotsford", "Coquitlam", "Kelowna", "Saanich", "Delta"],
    Manitoba: ["Winnipeg", "Brandon", "Steinbach", "Thompson", "Portage la Prairie", "Winkler", "Selkirk", "Morden", "Dauphin", "The Pas"],
    "New Brunswick": ["Saint John", "Moncton", "Fredericton", "Dieppe", "Miramichi", "Edmundston", "Bathurst", "Campbellton", "Oromocto", "Grand Falls"],
    "Newfoundland and Labrador": ["St. John's", "Mount Pearl", "Corner Brook", "Conception Bay South", "Grand Falls-Windsor", "Gander", "Happy Valley-Goose Bay", "Labrador City", "Stephenville", "Portugal Cove-St. Philip's"],
    "Nova Scotia": ["Halifax", "Dartmouth", "Sydney", "Truro", "New Glasgow", "Glace Bay", "Kentville", "Amherst", "Bridgewater", "Yarmouth"],
    Ontario: ["Toronto", "Ottawa", "Mississauga", "Brampton", "Hamilton", "London", "Markham", "Vaughan", "Kitchener", "Windsor", "Richmond Hill", "Oakville", "Burlington", "Greater Sudbury", "Oshawa"],
    "Prince Edward Island": ["Charlottetown", "Summerside", "Stratford", "Cornwall", "Montague", "Kensington", "Souris", "Alberton", "O'Leary", "Tignish"],
    Quebec: ["Montreal", "Quebec City", "Laval", "Gatineau", "Longueuil", "Sherbrooke", "Saguenay", "Levis", "Trois-Rivieres", "Saint-Jean-sur-Richelieu"],
    Saskatchewan: ["Saskatoon", "Regina", "Prince Albert", "Moose Jaw", "Swift Current", "Yorkton", "North Battleford", "Estevan", "Weyburn", "Meadow Lake"],
  },
  Australia: {
    "New South Wales": ["Sydney", "Newcastle", "Wollongong", "Central Coast", "Maitland", "Coffs Harbour", "Wagga Wagga", "Albury", "Tamworth", "Orange"],
    Victoria: ["Melbourne", "Geelong", "Ballarat", "Bendigo", "Shepparton", "Mildura", "Warrnambool", "Traralgon", "Wangaratta", "Wodonga"],
    Queensland: ["Brisbane", "Gold Coast", "Sunshine Coast", "Townsville", "Cairns", "Toowoomba", "Mackay", "Rockhampton", "Bundaberg", "Hervey Bay"],
    "Western Australia": ["Perth", "Mandurah", "Bunbury", "Geraldton", "Kalgoorlie", "Albany", "Karratha", "Broome", "Port Hedland", "Esperance"],
    "South Australia": ["Adelaide", "Mount Gambier", "Whyalla", "Murray Bridge", "Port Augusta", "Port Pirie", "Victor Harbor", "Kadina", "Naracoorte", "Millicent"],
    Tasmania: ["Hobart", "Launceston", "Devonport", "Burnie", "Ulverstone", "Queenstown", "George Town", "Wynyard", "Smithton", "Scottsdale"],
    "Northern Territory": ["Darwin", "Alice Springs", "Katherine", "Palmerston", "Tennant Creek", "Jabiru", "Nhulunbuy", "Yulara", "Jabiru", "Gove"],
    "Australian Capital Territory": ["Canberra", "Queanbeyan"],
  },
};

/** True if this country has state + city dropdown data (so we show dropdowns instead of manual input). */
export function hasStateCityDropdowns(country: string | undefined): boolean {
  return !!(country && COUNTRY_STATES[country]);
}

export const floatingDropdownActionsToArray = (
  floatingDropdownActions: ActionList
) => {
  let floatingDropdownActionArray: Action[] = [];
  for (let actionLabel in floatingDropdownActions) {
    const action = floatingDropdownActions[actionLabel];

    const newActionObj = {
      label: actionLabel,
      ...action,
    };

    floatingDropdownActionArray.push(newActionObj);
  }
  return floatingDropdownActionArray;
};

export const replaceNotListedLabelWithValue = (
  array: string[],
  elementToReplaceWith: string
) => {
  return [...array].map((element) =>
    element === "not-listed" ? elementToReplaceWith : element
  );
};

export const generateCheckboxValuesFromData = (
  checkboxesData,
  defaultValues
) => {
  const safeData = Array.isArray(checkboxesData) ? checkboxesData : [];
  const notListedFieldValue =
    safeData.find((value) => !defaultValues.includes(value)) || "";

  const newCheckboxesValues = safeData.map((checkboxesValue) => {
    if (!defaultValues.includes(checkboxesValue)) {
      return "not-listed";
    }
    return checkboxesValue;
  });

  return { newCheckboxesValues, notListedFieldValue };
};

const labelsCheckboxesValues = [
  "bipoc-led",
  "powerful-black-led",
  "powerful-brown-led",
  "powerful-indigenous-led",
  "woman-led",
  "lgbtq-led",
  "not-listed",
];

const communitiesServedCheckboxesValues = [
  "powerful-black-community",
  "powerful-brown-community",
  "powerful-indigenous-community",
  "woman",
  "lgbtq",
  "not-listed",
];

export const signupRadioButtons = [
  {
    label: "Which gender do you most identify with?",
    options: genderOptions,
    name: "gender",
    notListedField: "genderText",
  },
  {
    label: "Which pronouns do you most identify with?",
    options: pronounsOptions,
    name: "pronouns",
    notListedField: "pronounsText",
  },
  {
    label: "Which racial or ethnic category do you most identify with?",
    options: ethnicityOptions,
    name: "ethnicity",
    notListedField: "ethnicityText",
  },
];

type Location = {
  zip: string;
  city: string;
  state: string;
  address1: string;
  address2: string;
  longitude: number | null;
  latitude: number | null;
};

type OrgFields = {
  careModelCertified: string;  // you wrote "false" as string, so string type here
  ein: string;
  antiRacist: string;
  showPhone?: string;
  showAddress?: string;
};

type Image = {
  key: string;
  url: string;
};

export type AddOrgFormValues = {
  name: string;
  type: typeof type;   // assuming `type` is a variable, so you keep its type here
  mission: string;
  vision: string;
  problem: string;
  phoneNumber: string;
  sparks: any[];        // sparks is an array but you didn’t specify element type, so any[]
  location: Location;
  orgFields: OrgFields;
  labels: any[];        // labels is an array, same as sparks, specify type if known
  labelNotListed: string;
  communitiesServed: any[];  // array, type unknown
  communityServedNotListed: string;
  image: Image;
  step: string;         // "GENERAL_INFO" is initial, but probably a string union would be better if you have steps
  fundBy: string | null;
};


export const generateAddOrganizationInitialValues = (
  type: string,
  editMode: boolean,
  organizationData: Organization
) => {
  let initialValues = {
    name: "",
    type: type,
    mission: "",
    vision: "",
    problem: "",
    phoneNumber: "",
    fundBy: null,
    sparks: [],
    location: {
      zip: "",
      city: "",
      state: "",
      address1: "",
      address2: "",
      longitude: null,
      latitude: null,
      country: "United States",
    },
    orgFields: {
      careModelCertified: "false",
      ein: "",
      antiRacist: "",
      isBlackFundGrantee: false,
      showPhone: "true",
      showAddress: "true",
    },
    labels: [],
    labelNotListed: "",
    communitiesServed: [],
    communityServedNotListed: "",
    image: {
      key: "",
      url: "",
    },
    step: "GENERAL_INFO",
  };

  if (editMode && organizationData) {
    initialValues = {
      ...initialValues,
      ..._.cloneDeep(organizationData),
      fundBy: organizationData.fundBy || null,
    };
    if (initialValues.location && initialValues.location.country === undefined) {
      initialValues.location = { ...initialValues.location, country: "United States" };
    }
    if (initialValues.location) {
      const { latitude, longitude } = initialValues.location;
      initialValues.location.latitude =
        latitude === "" || latitude == null ? null : latitude;
      initialValues.location.longitude =
        longitude === "" || longitude == null ? null : longitude;
    }

    delete initialValues.createdAt;
    delete initialValues.updatedAt;
    delete initialValues.goals;
    delete initialValues.status;
    delete initialValues.members;
    delete initialValues.followerCount;
    delete initialValues.followingCount;
    delete initialValues.id;

    if (typeof initialValues.type === "string") {
      initialValues.type = initialValues.type.toLowerCase();
    }

    const { newCheckboxesValues: labels, notListedFieldValue: labelNotListed } =
      generateCheckboxValuesFromData(
        initialValues.labels,
        labelsCheckboxesValues
      );
    const {
      newCheckboxesValues: communitiesServed,
      notListedFieldValue: communityServedNotListed,
    } = generateCheckboxValuesFromData(
      initialValues.communitiesServed,
      communitiesServedCheckboxesValues
    );
    initialValues.labels = labels;
    initialValues.labelNotListed = labelNotListed;
    initialValues.communitiesServed = communitiesServed;
    initialValues.communityServedNotListed = communityServedNotListed;
    initialValues.mission = initialValues.mission ?? "";
    initialValues.vision = initialValues.vision ?? "";
    initialValues.problem = initialValues.problem ?? "";
    initialValues.image = initialValues.image ?? { key: "", url: "" };
    initialValues.sparks = Array.isArray(initialValues.sparks)
      ? initialValues.sparks
      : [];

    if (initialValues.orgFields && typeof initialValues.orgFields === "object") {
      initialValues.orgFields.careModelCertified = String(
        initialValues.orgFields.careModelCertified ?? "false"
      );
      if (initialValues.orgFields.ein != null && initialValues.orgFields.ein !== "") {
        initialValues.orgFields.ein = String(initialValues.orgFields.ein);
      }
      if (initialValues.orgFields.isBlackFundGrantee === undefined) {
        initialValues.orgFields.isBlackFundGrantee = false;
      }
      if (initialValues.orgFields.isBlackFundGrantee == null) {
        initialValues.orgFields.isBlackFundGrantee = false;
      }
      initialValues.orgFields.antiRacist =
        initialValues.orgFields.antiRacist ?? "";
      initialValues.orgFields.showPhone =
        initialValues.orgFields.showPhone === false ||
        initialValues.orgFields.showPhone === "false"
          ? "false"
          : "true";
      initialValues.orgFields.showAddress =
        initialValues.orgFields.showAddress === false ||
        initialValues.orgFields.showAddress === "false"
          ? "false"
          : "true";
    } else {
      initialValues.orgFields = {
        careModelCertified: "false",
        ein: "",
        antiRacist: "",
        isBlackFundGrantee: false,
        showPhone: "true",
        showAddress: "true",
      };
    }
  }

  return initialValues;
};

// metric

export const yearsForMetric = () => ["2030", "2029", "2028", "2027", "2026", "2025", "2024", "2023", "2022","2021", "2020"];

export const metricYearSelectInputOptions = () => {
  const options = yearsForMetric();
  return options.map((option) => ({
    label: option,
    value: option,
  }));
};

export const metricMonthOrQuaterFieldOptions = (quarter) => {
  if (quarter === "QUARTERLY") {
    return [
      { label: "Q1", value: "01-01" },
      { label: "Q2", value: "04-01" },
      { label: "Q3", value: "07-01" },
      { label: "Q4", value: "10-01" },
    ];
  }

  return [
    { label: "January", value: "01-01" },
    { label: "February", value: "02-01" },
    { label: "March", value: "03-01" },
    { label: "April", value: "04-01" },
    { label: "May", value: "05-01" },
    { label: "June", value: "06-01" },
    { label: "July", value: "07-01" },
    { label: "August", value: "08-01" },
    { label: "September", value: "09-01" },
    { label: "October", value: "10-01" },
    { label: "November", value: "11-01" },
    { label: "December", value: "12-01" },
  ];
};

export const generatePredeterminedMetricOptions = (metrics) =>
  metrics.map((metric) => {
    // Support both object array ({ metric: string }) and plain string[]
    const label = typeof metric === "string" ? metric : metric?.metric;
    return { label, value: label };
  });

export const formatNumber = (
  number: number | string,
  style: "currency" | "decimal"
) => {
  const options = {
    currency: style === "currency" ? "USD" : undefined,
    style,
  };

  return new Intl.NumberFormat("en-EN", options).format(number);
};

export const urlRegex = /^(https?):\/\/[^\s/$.?#].[^\s]*$/;

export const revertNumberOrCurrencyFormat = (s) => {
  return parseFloat(s.replace(/\,|\$|\%/g, "").trim());
};

export const capitalizeFirstLetter = (word: string) => {
  const sArray = word.split("");
  return `${sArray.shift().toUpperCase()}${sArray.join("")}`;
};

export const targetTypeToSymbols = {
  DOLLARS: "$",
  NUMBERS: "",
  PERCENTAGES: "%",
};

export const hasEmptyNotListedOtherField = (
  selections: string[] | undefined,
  otherText: string | undefined
): boolean =>
  Array.isArray(selections) &&
  selections.includes("not-listed") &&
  !String(otherText ?? "").trim();

export const disableAddOrEditFormButton = (
  step: string,
  formik: any,
  type: string
) => {
  if (step === "GENERAL_INFO") {
    const requiredChecks = {
      name: !!formik.values.name?.trim(),
      type: !!formik.values.type,
      phoneNumber: !!formik.values.phoneNumber?.trim(),
      address1: !!formik.values.location?.address1?.trim(),
      city: !!formik.values.location?.city?.trim(),
      state: !!formik.values.location?.state?.trim(),
      zip: !!formik.values.location?.zip?.trim(),
      labels: (formik.values.labels?.length ?? 0) > 0,
      communitiesServed: (formik.values.communitiesServed?.length ?? 0) > 0,
    };
    const hasRequiredFields = Object.values(requiredChecks).every(Boolean);

  const hasValidationErrors = (errors: Record<string, unknown>) => {
    const walk = (value: unknown): boolean => {
      if (!value) return false;
      if (typeof value === "string") return true;
      if (typeof value === "object") {
        return Object.values(value as Record<string, unknown>).some(walk);
      }
      return false;
    };
    return walk(errors);
  };

    const validationErrorsPresent = hasValidationErrors(formik.errors);

    if (validationErrorsPresent) {
      return true;
    }

    if (!hasRequiredFields) return true;

    if (
      hasEmptyNotListedOtherField(
        formik.values.labels,
        formik.values.labelNotListed
      ) ||
      hasEmptyNotListedOtherField(
        formik.values.communitiesServed,
        formik.values.communityServedNotListed
      )
    ) {
      return true;
    }

    if (type === "non-profit" || type === "foundation") {
      return !String(formik.values.orgFields?.ein ?? "").trim();
    }

    return false;
  }
  

  if (step === "SPARK") {
    return formik.values.sparks?.length > 5;
  }

  return true;
};
export const customConsole = (method, ...args) => {
  const MODE = `${import.meta.env.MODE}`;
  const IS_DEV = MODE === "development";
  if (!IS_DEV) return;
  if (console[method] && typeof console[method] === "function") {
    console[method](...args);
  } else {
    console.log(`Unsupported console method: ${method}`);
  }
};

export const truncate = (
  fullName,
  stringMaxLength = 68,
  stringTargetLength = 68
) => {
  if (!fullName?.length) return "";
  return fullName.length > stringMaxLength
    ? fullName.trim().substring(0, stringTargetLength - 3) + "..."
    : fullName.trim();
};

type Reaction =
  | "FOLLOW"
  | "TAG"
  | "HEART"
  | "FIST"
  | "SNAPS"
  | "HIGHFIVE"
  | "COMMENT";

export const generateNotificationMessage = (
  action: Reaction,
  postId: string | undefined,
  interactionId: string | undefined,
  hasOrg: boolean | undefined
) => {
  const reactionMessage = "just reacted to your post ";

  const wordsMap = {
    COMMENT: "just commented on your post",
    HEART: reactionMessage,
    FIST: reactionMessage,
    SNAPS: reactionMessage,
    HIGHFIVE: reactionMessage,
    FOLLOW: "just followed you",
    TAG: "just tagged you",
    ORG_INVITE_DECLINED: 'just declined your invitation',
    ORG_INVITE_ACCEPTED: 'just accepted your invitation',
    ORG_MEMBER_REMOVED: 'just removed you',
    ORG_ROLE_UPDATED: 'just updated your role',
    ORG_INVITE: 'just sent you an invite'
  };

  if (action === "TAG") {
    if (postId) {
      if (!interactionId) {
        return `${wordsMap[action]} on a post`;
      } else {
        return `${wordsMap[action]} on a comment`;
      }
    }
  }

  if(hasOrg && action === "ORG_INVITE_EXPIRED"){
    return ""
  }

  if(hasOrg && action === "ORG_MEMBER_REMOVED"){
    return `${wordsMap[action]} from the organization named: `
  }

  if(hasOrg && action === "ORG_ROLE_UPDATED"){
    return `${wordsMap[action]} in the organization named: `
  }

  if(hasOrg){
     return `${wordsMap[action]} to join the organization named: `
  }

  return wordsMap[action];
};

export const getUsersFromTags = (text) => {
  const tags = [...text.matchAll(/@\[(.+?)\]\((.+?)\)/g)];
  const allUserIds = tags.map((myTag) => {
    console.log("My TAG", myTag);
    const id = myTag[2];
    const name = myTag[1];
    return { id, name };
  });
  return _uniqBy(allUserIds, (myUser) => myUser.id);
};

export const isOrganization = (
  entity: User | Organization
): entity is Organization => {
  return (entity as Organization).type !== undefined;
};

export const months = [
  'January', 'February','March', 'April', 'May','June','July',
  'August', 'September', 'October', 'November', 'December'
];

export const monthsAbbrevationMap = {
  'January': 'Jan',
  'February': 'Feb',
  'March': 'Mar',
  'April': 'Apr',
  'May': 'May',
  'June': 'Jun',
  'July': 'Jul',
  'August': 'Aug',
  'September': 'Sep',
  'October': 'Oct',
  'November': 'Nov',
  'December': 'Dec'
};

export const generateYears = () => {

  const currentYear = new Date().getFullYear();
  let year = 2020;

  const years = [2020];

  let i = 1;

  while (year < currentYear){
    year++;
    years.push(year);
    i++
  }

  return years;
}


export const generateGraphYearOptions = () => {

  const years = generateYears();

  return years.map(year => ({label: `${year}`, value: year})).reverse();
}

export const generateGraphMonthOptions = () => {

  return months.map(month => ({ label: month, value: month }));
}

export const MONTH_ORDER = {
  January: 1, February: 2, March: 3, April: 4, May: 5, June: 6,
  July: 7, August: 8, September: 9, October: 10, November: 11, December: 12,
  Jan: 1, Feb: 2, Mar: 3, Apr: 4, Jun: 6, Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12
};